import { render, staticRenderFns } from "./NotificationDay.vue?vue&type=template&id=2da912db"
import script from "./NotificationDay.vue?vue&type=script&lang=js"
export * from "./NotificationDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports